import blockchairLogo from '@/assets/images/logo/blockchair.svg';
import veritasLogo from '@/assets/images/logo/veritas.svg';
import trusteeLogo from '@/assets/images/logo/trustee.svg';

export type PartnerKey = 'blockchair' | '894e1' | 'trustee';

type Partner = {
  logo: string;
  label: string;
};

export const LOGOS: Record<PartnerKey, Partner> = {
  blockchair: {
    logo: blockchairLogo,
    label: 'Blockchair',
  },
  '894e1': {
    logo: veritasLogo,
    label: 'Veritas',
  },
  trustee: {
    logo: trusteeLogo,
    label: 'Trustee',
  },
};

export const allowedPartners: PartnerKey[] = ['blockchair', '894e1', 'trustee'];

export const DEFAULT_WIDGET_APP_ID = (import.meta.env
  .VITE_REACT_APP_AMLBOT_WIDGET_APP_ID as string)!;
